"use client";
import { makeStyles } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { ConstrainedContent } from "../components/layout/ConstrainedContent";
import { TabView, TabViewInfo } from "../components/TabView";
import ArchivedLinkList from "../components/tool/ArchivedLinkList";
import DraftLinkList from "../components/tool/DraftLinkList";
import PublishedLinkList from "../components/tool/PublishedLinkList";
import { useGetUserAccessLevel } from "../hooks/useGetUserAccessLevel";

const useClasses = makeStyles({
  root: {
    overflow: "visible",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
  },
});

const LinksToolsPage = () => {
  const { t } = useTranslation();
  const classes = useClasses();

  const [searchParams] = useSearchParams();
  const view = searchParams.get("view") ?? "published";

  const accessLevel = useGetUserAccessLevel();

  const tabInfos: TabViewInfo[] = [
    { text: t("published"), value: "published" },
    { text: t("drafts"), value: "drafts" },
  ];

  if (accessLevel >= 3) {
    tabInfos.push({ text: t("archivedListTab"), value: "archived" });
  }

  return (
    <div className={classes.root}>
      <ConstrainedContent>
        <h1>{t("links")}</h1>
        <TabView
          tabInfos={tabInfos}
          defaultTabValue={view}
          onTabChange={() => undefined}
        />
      </ConstrainedContent>

      {view === "published" && <PublishedLinkList />}

      {view === "drafts" && <DraftLinkList />}

      {view === "archived" && accessLevel >= 3 && <ArchivedLinkList />}
    </div>
  );
};

export default LinksToolsPage;
